export class HandledException {
  constructor(
    public message?: string
  ) {

  }
}



// WEBPACK FOOTER //
// ./src/app/utilities/exceptions/HandledException.ts